import {Links} from './links.model';
import {Hal} from './hal.model';

export class UserHal extends Hal {
  identification: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
  additionalInfo: string;

  constructor(data: any) {
    super(data);
    this.identification = data.identification;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.phone = data.phone;
    this.company = data.company;
    this.additionalInfo = data.additionalInfo;
    this._links = new Links(data._links)
  }
}

